import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const ActionTypes          = {
    SET_LIGHT_BOX_DATA_THEN_SHOW: 'SET_LIGHT_BOX_DATA_THEN_SHOW',
    SET_CUSTOM_STYLES           : 'SET_CUSTOM_STYLES'
}
Vue.prototype.$ActionTypes = ActionTypes

export default new Vuex.Store({
    state    : {
        scClient             : null,
        scSubscribeChannel   : null,
        clientId             : '',
        clientName           : '',
        clientToken          : '',
        botCode              : '',
        subChannel           : '',
        componentsMainChatBox: null,
        componentsMainApp    : null,
        bot_icon             : '',
        styles               : null,
        lightBoxData         : [],
        lightBoxIndex        : null,
        customSender         : false,
        startPayload         : '',
        suggestionList       : [],
        isChatWithBot        : false,
    },
    mutations: {
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (state, payload) => {
            if (payload.data && payload.data.length > 0) {
                state.lightBoxData  = [...payload.data]
                state.lightBoxIndex = payload.index || payload.index === 0 ? payload.index : null
            } else {
                state.lightBoxData  = []
                state.lightBoxIndex = null
            }
        },
        [ActionTypes.SET_CUSTOM_STYLES]           : (state, payload) => {
            state.styles = payload
        }
    },
    actions  : {
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (context, payload) => {
            context.commit(ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, payload)
        },
        [ActionTypes.SET_CUSTOM_STYLES]           : (context, payload) => {
            context.commit(ActionTypes.SET_CUSTOM_STYLES, payload)
        }
    }
})
